module.exports = __webpack_public_path__ + "img/innovacion.69dc9daa.jpg";